import React from 'react';
import { Button } from '@keplerco/core';
import styles from '../../freemium-dashboard/freemium-dashboard.layout.module.css';
import { useNavigate } from 'react-router';

interface Stat {
  value: number;
  label: string;
}

interface FeatureCardProps {
  title: string;
  description: string;
  stats?: Stat[];
  actionLabel?: string;
  actionPath?: string;
  locked?: boolean;
  upgradeAction?: () => void;
}

/**
 * Feature card component for the dashboard
 * Displays a feature with stats, description, and action button
 */
export function FeatureCard({
  title,
  description,
  stats,
  actionLabel,
  actionPath,
  locked = false,
  upgradeAction
}: FeatureCardProps): JSX.Element {
  const navigate = useNavigate();
  
  const handleAction = () => {
    if (locked && upgradeAction) {
      upgradeAction();
    } else if (actionPath) {
      navigate(actionPath);
    }
  };
  
  return (
    <div className={`${styles.card} ${locked ? styles.lockedFeature : ''}`}>
      <div className={styles.cardTitle}>{title}</div>
      <div className={styles.cardDescription}>{description}</div>
      
      {stats && stats.length > 0 && (
        <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
          {stats.map((stat, index) => (
            <div key={index} className={styles.stat}>
              <div className={styles.statValue}>{stat.value}</div>
              <div className={styles.statLabel}>{stat.label}</div>
            </div>
          ))}
        </div>
      )}
      
      {actionLabel && (
        <div className={styles.cardFooter}>
          <Button onClick={handleAction} type="button">
            {locked ? 'Unlock' : actionLabel}
          </Button>
        </div>
      )}
      
      {locked && (
        <div className={styles.lockedOverlay}>
          <div className={styles.lockIcon}>🔒</div>
          <div style={{ fontWeight: 'bold', marginBottom: '8px' }}>Pro Feature</div>
          <div>Upgrade to access this feature</div>
          <Button 
            type="button"
            style={{ marginTop: '16px' }} 
            onClick={upgradeAction}
          >
            Upgrade Now
          </Button>
        </div>
      )}
    </div>
  );
}
